import emptySplitApi from "../utils/rtk";
import { CommonBody, ReligionList } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetReligionsResponse = {
  length: number;
  start: number;
  response_object: ReligionList[];
  total_records: number;
};

export const religionApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getReligions: builder.mutation<
      CommonResponseType & { data: GetReligionsResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getAllReligion,
        method: "POST",
        body,
      }),
    }),

    deleteReligion: builder.query<
      CommonResponseType & { data: ReligionList },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteReligion}${id}/`,
        method: "DELETE",
      }),
    }),
    changeReligionStatus: builder.mutation<
      CommonResponseType & { data: ReligionList },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.changeReligionStatus}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    religionDetails: builder.query<
      CommonResponseType & { data: ReligionList | null },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getReligionDetails}${id}/`,
        method: "GET",
      }),
    }),
    updateReligion: builder.mutation<
      CommonResponseType & { data: ReligionList },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateReligion}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    addReligion: builder.mutation<
      CommonResponseType & { data: ReligionList },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addReligion,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetReligionsMutation,
  useLazyReligionDetailsQuery,
  useLazyDeleteReligionQuery,
  useChangeReligionStatusMutation,
  useUpdateReligionMutation,
  useAddReligionMutation,
} = religionApi;
